import InputNumber from './InputNumber';

interface Props {
    value: number | string;
    className?: string;
    thousandSeparator?: boolean;
    decimalScale?: number
}

/**
 * 숫자 표시
 * @param value - 기본값
 * @param className - 추가 className
 * @param thousandSeparator - 천단위 콤마(기본: true)
 * @param decimalScale - 소수점 자리수 제한(기본: 2)
 */
export default function DisplayNumber({
                                          value,
                                          className = '',
                                          thousandSeparator = true,
                                          decimalScale = 2
                                      }: Props) {
    return (
        <InputNumber
            value={value === null || value === undefined ? '' : value} // 0 일 수 있기에 해당 로직으로 구성
            className={`text-end ${className}`}
            thousandSeparator={thousandSeparator}
            displayType={'text'}
            decimalScale={decimalScale}
        />
    );
}
